import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { ShopOutlined, WarningOutlined } from "@ant-design/icons";

export const MassiveGroupHeader = (props: { numberOfLocations: number }) => {

    const { projectGroup } = useAuth();    
	const allGroups = projectGroup.group.includes(',');    

    return (
        <div
            style={{
                background: 'white', // Siempre azul de fondo
                borderRadius: 10,
                padding: '6px 32px 6px 16px',
                border: 'solid .5px var(--primary-dark)',
                color: 'var(--primary-dark)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                margin: '0px 12px',
                minHeight: 0,
                minWidth: 240,
                gap: 14,
                fontSize: 16
            }}
        >
            <span style={{ fontSize: 20, marginRight: 6, display: 'flex', alignItems: 'center' }}>
                <ShopOutlined />
            </span>
            <span style={{ fontWeight: 600, fontSize: 19, marginRight: 3 }}>
                {props.numberOfLocations}
            </span>
            <span style={{ fontWeight: 500, fontSize: 15, marginRight: 18 }}>
                locales
            </span>
            <span
                style={{
                    fontWeight: 600,
                    fontSize: 15,
                    color: allGroups ? 'white' : '#718096',
                    background: allGroups ? 'darkorange' : '#edf2f7',			
                    borderRadius: 10,
                    padding: "2px 14px"
                }}
            >
                {projectGroup.group.includes(',') && <WarningOutlined/> } {projectGroup.groupName}
            </span>
        </div>
    );
};